<template>
  <div class="h-screen-dis">
    <div ref="formContainer" :class="mainClass">
      <div v-if="siteInfo.ErrorMsg.length > 0" id="ci_error_msg" class="hwifMk">
        <div class="msg">{{ siteInfo.ErrorMsg }}</div>
        <div class="btn" @click="deleteError">X</div>
      </div>
      <main v-if="formInfo.Status === 'Unpublished'">
        <div class="submit-result" style="display: none;">
          <div>The form has been unpublished.</div>
        </div>
      </main>
      <main v-else-if="state.status === 0">
        <div class="form-view-title" v-if="queryId > 0" v-html="formInfo.Title"></div>
        <Vueform ref="form" v-model="formData" :class="themedFormClass" :schema="formSchema" :endpoint="getEndpoint" />
      </main>
      <main v-else-if="state.status === 1">
        <div class="submit-result" v-if="customSuccessInfo != ''">
          <div v-html="customSuccessInfo"></div>
          <div>
            <button @click="resetForm" :class="btnClass" :style="btnStyle">OK</button>
          </div>
        </div>
        <div class="submit-result" v-else-if="isSchoolHoursForm">
          <div>School Hours have been successfully submitted.</div>
          <div>
            <button @click="resetForm" :class="btnClass" :style="btnStyle">OK</button>
          </div>
        </div>
        <div class="submit-result" v-else>
          <div>Your form has been successfully submitted.</div>
          <div>Thank you.</div>
          <div>
            <button @click="resetForm" :class="btnClass" :style="btnStyle">Close</button>
          </div>
        </div>
      </main>
      <main v-else-if="state.status === 2">
        <div class="submit-result">
          <div>Your submission failed.</div>
          <div>Please try again.</div>
          <div>
            <button @click="resetForm" :class="btnClass" :style="btnStyle">Close</button>
          </div>
        </div>
      </main>
      <main v-else-if="state.status === 3">
        <div class="submit-result">
          <div>Canceled.</div>
          <div>
            <button @click="resetForm" :class="btnClass" :style="btnStyle">Close</button>
          </div>
        </div>
      </main>
      <main v-else-if="state.status === 4">
        <div class="submit-result">
          <div>Not Paid: {{ state.note }}</div>
          <div>
            <button @click="resetForm" :class="btnClass" :style="btnStyle">Close</button>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { emptyData } from '../data';
import { apiConfig } from '../config/api';
import { getFormStatus, formatFormData, findRedirectUrlFromFormData, uploadFiles, getUploadFiles, modifySchema, getPirceInfo, findFieldByPath, setAttrValue, urlQuery, tryFindRedirectUrl } from '../utilities/dataHelper';

import { getQueryId } from "../config/builderConfig";

export default {
  name: 'Form',
  data() {
    return {
      formData:{},
      priceInfo: {},
      pcCnt: 0,
      resizeCnt: 0,
      schoolHoursData: '',
      isSchoolHoursForm: false,      
      customSuccessInfo: '',
      queryId: getQueryId(this.$route.query),
      pageUrl: window.location.href,
      mainClass: 'ci-form-main-iframe',
      themedFormClass: 'themed-form',
      btnClass: 'btn-close inline-block transition form-border-width-btn form-shadow-btn focus:outline-zero form-bg-btn form-color-btn form-border-color-btn form-p-btn form-radius-btn form-text cursor-pointer transition-transform ease-linear focus:form-ring transform hover:scale-105',
      btnStyle: '',
      formSchema: emptyData.schema,
      siteInfo: {
        ErrorMsg: '',
        EnableSave: false
      },
      formInfo: {
        Title: 'My Form',
        //Id: parseInt(this.$route.params['formId'] || 0),
        Uid: this.$route.params['formId'],
        Id: 0,
        SiteId: 5,
        FolderId: 0,
        Data: '',
        Status: "Published",
        HasPub: false,
        HasDraft: false
      },
      state: {
        resizeObserve: null,
        // status: 0: init, 1: success, 2: failed
        status: 0,
        note: '',
        submit: 0,
        height: 0
      },
      parentInfo: {
        init: false,
        itmId: 0,
        pageUrl: '',
        siteId: 0,
        theme: null,
        title: '',
        isMobile: false
      },
      theme: {
        primary: 'rgb(0, 120, 212)',
        darker: 'rgb(0, 120, 212)'
      }
    }
  },
  methods: {
    deleteError() {
      this.siteInfo.ErrorMsg = '';
    },
    getFormSchema() {
      if(this.$route.params["submissionId"]) {
        this.isSchoolHoursForm = true;
      }

      if (this.pageUrl.indexOf('result=ok') > 0) {
        this.state.status = 1;
      } else if (this.pageUrl.indexOf('result=canceled') > 0) {
        this.state.status = 3;

      } else if (this.pageUrl.indexOf('result=notpaid') > 0) {
        this.state.status = 4;
        this.state.note = urlQuery(window.location.href, 'note');

      }
      axios({
        method: 'get',
        url: `${apiConfig.GetApiUrl}/${this.formInfo.Uid}`,
      }).then((res) => {

        let result = res.data;

        const status = getFormStatus(result);
        const title = result.title;
        let _fromData = (status === 'Unpublished') ? '' : (result.data || "");
        if (_fromData.length < 100) {
          _fromData = JSON.stringify(emptyData);
        }
        this.formInfo = {
          Id: parseInt(result.id),
          SiteId: parseInt(result.siteId || 5),
          FolderId: parseInt(result.folderId),
          Title: title,
          Uid: this.$route.params["formId"],
          Data: _fromData,
          Status: status
        };

        this.resizeFormHeight(result.id);

        this.formSchema = modifySchema(JSON.parse(_fromData).schema);

        // setTimeout(() => {
          
        //   this.setWatcher(this.formSchema);
        // }, 500);
        this.loadFormData();


        if (status === 'Unpublished') {
          this.hideUnpublishedForm();
        }

      }).catch(e => {
        console.error('[get form schema] error:', e);
        this.siteInfo.ErrorMsg = `getting form schema error: ${e.message}`;
        this.formSchema = emptyData.schema;
      });


    },
    loadEmptyData() {
    },
    submitSuccess() {
      this.state.status = 1;
      this.parentScrollTop();
    },
    submitFailed(msg) {
      this.state.status = 2;
      if (msg) {
        this.siteInfo.ErrorMsg = msg;
      }
      this.parentScrollTop();
    },
    submitCanceled(msg) {
      this.state.status = 2;
      if (msg) {
        this.siteInfo.ErrorMsg = msg;
      }
      this.parentScrollTop();
    },
    loadSchoolHoursFormData(formData, n) {
      if (this.$refs.form) {
        this.$refs.form.update(formData);
      } else {
        setTimeout(() => {
          this.loadSchoolHoursFormData(formData, n + 1);
        }, 200);
      }
    },
    resetForm() {
      if (this.$route.params["submissionId"]) {
        this.state.status = 0;
        this.state.submit = 0;

        if (this.schoolHoursData) {
          const formData = JSON.parse(this.schoolHoursData);
          this.loadSchoolHoursFormData(formData, 0);
        }
      } else if (this.pageUrl.indexOf('result=ok') > 0) {
        
        const redirectUrl = tryFindRedirectUrl(this.formSchema);
        //console.log('[resetForm] redirectUrl', redirectUrl);
        window.location.href = redirectUrl || this.pageUrl.replace("?result=ok", "?").replace("&result=ok", "");
      } else if (this.pageUrl.indexOf('result=canceled') > 0) {
        window.location.href = this.pageUrl.replace("?result=canceled", "?").replace("&result=canceled", "")
      } else if (this.pageUrl.indexOf('result=notpaid') > 0) {
        
        let note = urlQuery(window.location.href, 'note');
        window.location.href = this.pageUrl.replace("?result=notpaid", "?").replace("&result=notpaid", "").replace(`&note=${note}`, "")
      }else {
        this.state.status = 0;
        this.state.submit = 0;
      }
    },
    getEndpoint(formData$, form$) {

      if (this.state.submit > 0) {
        return;
      }
      this.state.submit = 1;


      let data = form$.requestData || {};
      let files = getUploadFiles(data, this.formInfo.Uid, this.formSchema);


      if (files && files.length > 0) {
        this.submitWithFiles(data, files);
      } else {
        this.submit(data);
      }
    },
    submit(data, files) {

      const res = formatFormData(data, files, this.formSchema);

      let formData = {
        FormUid: this.formInfo.Uid,
        PageId: (this.parentInfo.itmId || this.queryId) || 5,
        PageUrl: this.parentInfo.pageUrl || this.pageUrl,
        Data: JSON.stringify(res)
      };
      if (this.$route.params["submissionId"]) {
        formData.SubmissionId = parseInt(this.$route.params["submissionId"]);
        this.schoolHoursData = formData.Data;
      }

      if (res.ciPriceTotal && res.ciPriceTotal > 0) {
        let priceInfo = {
          Items: []
        };
        priceInfo.Items.push({
          Title: this.formInfo.Title,
          Rate: res.ciPriceTotal * 100,
          Quantity: 1
        });
        formData = { ...formData, Price: priceInfo };
      }

      if (formData.PageId === 0) {
        console.error('[submit] no endpoint');
        this.submitFailed('no pageId');
      } else {

        const fd = findRedirectUrlFromFormData(formData);
        this.customSuccessInfo = '';
        axios.post(apiConfig.endpoint, fd.formData).then(res => {
          if (res.status === 200) {

            // const redirectUrl = tryFindRedirectUrl(this.formSchema);
            // if(redirectUrl) {
            //   window.top.location.href = redirectUrl;
            // } else 
            if(res.data && res.data.submUid && fd.redirectUrl) {
              window.top.location.href = fd.redirectUrl;

            } else if (res.data && res.data.returnUrl && res.data.returnUrl.length > 0) {

              window.top.location.href = res.data.returnUrl;
            } else {
              this.customSuccessInfo = res.data.content || '';
              this.submitSuccess();
            }

          } else {
            this.submitFailed(`submit error: ${res.status}`);
          }

        }).catch(e => {
          console.error('[submit] error:', e);
          this.submitFailed(`submit error: ${e.message}`);

        });
      }
    },
    submitWithFiles(data, files) {
      uploadFiles(files).then((res) => {

        this.submit(data, files);
      }).catch(e => {
        console.error('[submitWithFiles] error:', e);
        this.siteInfo.ErrorMsg = `submit error: ${e.message}`;
        this.submitFailed(`submit error: ${e.message}`);

      });
    },
    checkIframe() {
      if ((window.frameElement && window.frameElement.tagName === 'IFRAME') || (window !== window.top)) {

        window.addEventListener("message", (e) => {
          if (e.data.type === 'Form.Branding') {
            if (!this.parentInfo.init) {
              console.info('[Form.Branding]', e.data.ci);
              let res = e.data.ci;
              this.parentInfo = {
                init: true,
                itmId: res.itmId || 0,
                pageUrl: res.pageUrl || this.pageUrl,
                siteId: res.siteId || 0,
                theme: res.theme || {},
                title: res.title || ''
              };

              if (res.theme && res.theme.pb) {
                this.theme.primary = res.theme.pb;
                this.theme.darker = res.theme.pd || res.theme.pb;
                this.btnStyle = `background-color:${res.theme.pb}!important;`;
              }
              if (res.isMobile) {
                this.parentInfo.isMobile = true;
                this.mainClass = 'ci-form-main-iframe ci-form-main-iframe-mobile';
              } else if (this.queryId === 0) {

                //this.themedFormClass = 'themed-form-left';
                this.mainClass = 'ci-form-main-iframe-left';
              }

              if ((res.pageUrl && res.pageUrl.indexOf('result=ok') > 0) || this.pageUrl.indexOf('result=ok') > 0) {
                this.state.status = 1;
              } else if ((res.pageUrl && res.pageUrl.indexOf('result=canceled') > 0) || this.pageUrl.indexOf('result=canceled') > 0) {

                this.state.status = 3;
              } else if ((res.pageUrl && res.pageUrl.indexOf('result=notpaid') > 0) || this.pageUrl.indexOf('result=notpaid') > 0) {
                this.state.note = urlQuery(window.location.href, 'note');
                this.state.status = 4;
              }
            }
          } else if (e.data.type === 'Form.SchoolHoursData') {

            let formData = e.data.formData;
            if(formData) {
              this.$refs.form.update(formData);
            }
          } else {
            console.info('[Form.Branding] e', e);

          }
        }, false);


        this.$nextTick(() => {
          if (!this.state.resizeObserve) {
            this.state.resizeObserve = new ResizeObserver((entires) => {

              this.resizeFormHeight();
            });
          }
          this.state.resizeObserve.observe(this.$refs.formContainer);
        });

      } else {
        this.mainClass = 'ci-form-main';
      }
    },
    parentScrollTop() {
      try {
        let cbMsg = {
          type: 'Form.ScrollTo',
          x: 0,
          y: 0
        };
        console.info('[postMessage] msg', cbMsg);

        parent.postMessage(cbMsg, "*");
      } catch (e) {
        console.log('[parentScrollTop] e', e);
      }
    },
    getFormDataFromParent(id, formId) {

      let cbMsg = {
        type: 'Form.SchoolHoursData',
        id: id,
        formId: formId
      };
      console.info('[postMessage] msg', cbMsg);

      parent.postMessage(cbMsg, "*");
    },
    resizeFormHeight(id) {
      id = id || this.formInfo.Id;
      let formHeight = 0;
      let needRetry = true;


      if (this.pageUrl.indexOf('?item=')) {
        try {
          let pc = window._ci.PrimaryColor;
          this.theme.primary = pc;
          this.btnStyle = `background-color:${pc}!important;border-color:${pc}!important;`;
        } catch (e) {
        }

      }

      try {
        let formWrapper = document.getElementsByClassName('ci-ctn-wrapper')[0];
        formHeight = formWrapper.clientHeight;
        if (formWrapper.offsetHeight > formHeight) {
          formHeight = formWrapper.offsetHeight;
        }
        if (formWrapper.scrollHeight > formHeight) {
          formHeight = formWrapper.scrollHeight;
        }
        needRetry = false;
      } catch (e) {
        //console.log('[resizeFormHeight] wrapperHeight error*', e);
        formHeight = this.$refs.formContainer?.offsetHeight;
      }

      if (formHeight && formHeight !== this.state.height) {
        let formId = id || this.formInfo.Id;
        this.state.height = formHeight;
        let cbMsg = {
          type: 'Form.Resize',
          id: parseInt(formId),
          val: formHeight + (needRetry ? 120 : 0)
        };
        console.info('[postMessage] msg', cbMsg);
        if (cbMsg.id) {
          parent.postMessage(cbMsg, "*");
        }

      } else {

      }


      this.resizeCnt = this.resizeCnt + 1;
      if (needRetry && this.resizeCnt < 5) {
        setTimeout(() => {
          this.resizeFormHeight(id);
        }, 500);

      } else {
        this.resizeCnt = 0;
      }

    },
    hideUnpublishedForm() {

      let formId = this.formInfo.Id;
      let cbMsg = {
        type: 'Form.Resize',
        id: formId,
        val: 0
      };
      console.info('[postMessage]', cbMsg);
      parent.postMessage(cbMsg, "*")
    },

    getPrimaryColor() {

      if (this.pcCnt < 5 && this.pageUrl.indexOf('?item=')) {
        try {
          // let formHeader = document.getElementsByClassName('ci-ctn-header')[0];
          // let pc = window.getComputedStyle(formHeader).backgroundColor;
          // this.theme.primary = pc;


          let pc = window._ci.PrimaryColor;
          this.theme.primary = pc;
          this.btnStyle = `background-color:${pc}!important;border-color:${pc}!important;`;
        } catch (e) {

          console.error('[resizeFormHeight] pc error', this.pcCnt, e);
        }

        this.pcCnt = this.pcCnt + 1;
        setTimeout(() => {
          this.getPrimaryColor();
        }, 500);
      }
    },
    loadFormData() {
      if (this.$route.params["submissionId"]) {
        let submissionId = parseInt(this.$route.params["submissionId"]);

        this.getFormDataFromParent(submissionId);
      }
    },

  },
  created() {

  },
  async mounted() {
    this.checkIframe();
    //this.loadTempData();
    this.getFormSchema();
    //this.getPrimaryColor();
  },
}
</script>
<style lang="scss">
.themed-form {
  padding: 0 5px;

  *,
  &:before,
  &:after,
  &:root {
    --vf-primary: v-bind(theme.primary);
    --vf-ring-color: v-bind(theme.darker);
  }
}

.themed-form-left {
  padding: 0 10px 0 0;

  *,
  &:before,
  &:after,
  &:root {
    --vf-primary: v-bind(theme.primary);
    --vf-ring-color: v-bind(theme.darker);
  }
}

.submit-result {
  .btn-close {
    background-color: var(--vf-primary);
    width: 120px;
  }

  div {
    font-size: 16px;
    line-height: 44px;
  }
}

.ci-form-main-iframe {
  padding: 10px 20px 100px 10px;
}

.ci-form-main-iframe-left {
  padding: 10px 30px 100px 0;
}

.ci-form-main-iframe-mobile {
  padding: 10px 0 30px 0 !important;
}
</style>